import { GoogleAnalytics } from "../../googleAnalytics";
import settings from "./_settings";

const sitemapFailed = (provider: string) => {
    GoogleAnalytics.reportEvent({ 
        name: `${settings.scope}:${settings.categoryName}:${provider}:failed`, 
        category: settings.categoryName 
    });
};

export default sitemapFailed;